<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 md2>
        <h3>Links
        <v-dialog v-model="dialog" max-width="500px" @keydown.esc="close" persistent lazy>
          <template v-slot:activator="{ on }">
            <v-icon
              style="margin-bottom:-2px;"
              :disabled="!getWikiEntity.EntityTypeRelations.length" v-on="on">add</v-icon>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-select
                      :items="allowedWikiDirectedLinkTypes"
                      item-value="directed_link_type_key"
                      item-text="directed_link_type_label"
                      v-model="editedItem.directed_link_type_key"
                      label="Link Type"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 md12 v-show="editedItem.directed_link_type_key">
                    <v-autocomplete
                      :items="allowedCurrentWikiEntitiesBySelectedLinkType"
                      item-value="entity_id"
                      item-text="entity_name"
                      v-model.number="editedItem.linked_entity_id"
                      label="Entity"
                      :disabled="newEntityCheckbox"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout wrap v-show="editedItem.directed_link_type_key">
                  <v-flex xs12 sm12 md12>
                    <v-checkbox
                      v-model="newEntityCheckbox"
                      label="Add an entity to the list"
                    ></v-checkbox>
                  </v-flex>
                  </v-layout>
                  <v-layout wrap v-if="newEntityCheckbox">
                    <v-flex xs4 sm12 md12>
                        <v-text-field
                          v-model="newEntityName"
                          placeholder="Enter a name"
                          maxlength="255"
                          label="New entity" />
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-select
                        :items="allowedEntityTypes"
                        item-value="entity_type_id"
                        item-text="entity_type_name"
                        v-model.number="newEntityTypeId"
                        label="Entity Type"
                      ></v-select>
                    </v-flex>
                    <v-flex xs4 sm12 md12>
                        <ApolloMutation
                          :mutation="require('@/graphql/Wiki/CreateWikiChangeRequest.gql')"
                          :variables="dialog && {
                            WikiChangeRequestInput: {
                              target_type: 'wiki_entity',
                              request_type: 'create',
                              ChangeRequestFields: [{
                                target_field: 'entity_name',
                                new_value_text: this.newEntityName
                              }, {
                                target_field: 'entity_type_id',
                                new_value_fk: newEntityTypeId
                              }]
                            }
                          } || {}"
                          @done="onDone"
                          :update="updateCreatedEntity"
                          @error="addError($event.message)"
                        >
                          <template slot-scope="{ mutate, loading }">
                            <v-list-tile-action >
                              <v-btn style="margin-right: 15px; padding-left: 10px; padding-right: 10px;" class="white--text" color="indigo"
                              :disabled="!newEntityName || !newEntityTypeId || loading"
                              @click="mutate()">Create</v-btn>
                            </v-list-tile-action>
                          </template>
                        </ApolloMutation>
                    </v-flex>
                </v-layout>
                <v-layout wrap v-show="editedItem.directed_link_type_key">
                  <v-flex xs12 sm12 md12>
                    <v-textarea
                      outline
                      :counter="1000"
                      v-model="editedItem.link_note"
                      label="Link note" />
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                      <br />
                      <br />
                      <v-textarea
                        color="orange orange-darken-4"
                        outline
                        :counter="1000"
                        v-model="comment"
                        label="Source of knowledge"
                        required />
                    </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <ApolloMutation
                :mutation="require('@/graphql/Wiki/CreateWikiChangeRequest.gql')"
                :variables="dialog && {
                  WikiChangeRequestInput: {
                    target_type: 'wiki_link',
                    request_type: this.editedIndex === -1 ? 'create' : 'update',
                    target_id: this.editedItem.link_id,
                    comment: this.comment || '',
                    ChangeRequestFields: [{
                      target_field: 'entity_1_id',
                      new_value_fk: (this.selectedDirectedLinkType && this.selectedDirectedLinkType.directed_link_type_direction === '1to2') ? this.getWikiEntity.entity_id : this.editedItem.linked_entity_id
                    }, {
                      target_field: 'link_type_id',
                      new_value_fk: this.selectedDirectedLinkType && this.selectedDirectedLinkType.link_type_id
                    }, {
                      target_field: 'entity_2_id',
                      new_value_fk: (this.selectedDirectedLinkType && this.selectedDirectedLinkType.directed_link_type_direction === '1to2') ? this.editedItem.linked_entity_id : this.getWikiEntity.entity_id
                    }, {
                      target_field: 'link_note',
                      new_value_text: this.editedItem.link_note
                    }]
                  }
                } || {}"
                @done="close()"
                @error="addError($event.message)"
              >
                <template slot-scope="{ mutate, loading }">
                  <v-btn color="primary" flat @click="close">Cancel</v-btn>
                  <v-btn color="primary" @click="mutate()" :disabled="newEntityCheckbox || loading  || disableSaveBtn">Save</v-btn>
                </template>
              </ApolloMutation>
            </v-card-actions>
          </v-card>
        </v-dialog></h3>

      </v-flex>
      <v-flex xs12 md10 style="padding-top:3px;">
        <v-layout row wrap v-for="directedLinkType in directedEntityLinkTypes" :key="directedLinkType.directed_link_type_key">
          <v-flex xs4 md2>
            <span v-text="directedLinkType.directed_link_type_label"/>:
          </v-flex>
          <v-flex xs8 md10>
            <div v-for="directedLink in getWikiEntity.DirectedLinks.filter(attr => attr.directed_link_type_key == directedLinkType.directed_link_type_key)" :key="directedLink.directed_link_key">
              <a href="#" @click="showEntity(directedLink.linked_entity_id); onClickOpen('click-showmore', directedLink.linked_entity_id, directedLink.linked_entity_name)" ><span v-text="directedLink.linked_entity_name"/></a>&nbsp;
              <v-tooltip top v-show="directedLink.link_note">
                <v-icon style="font-size: 18px;" slot="activator" >help_outline</v-icon>
                <span v-text="directedLink.link_note" />
              </v-tooltip>
              <v-icon
                small
                @click="editItem(directedLink)"
              >
                edit
              </v-icon>
              <v-dialog v-model="dialogDelete[directedLink.link_id]" max-width="350px"  persistent>
                <template v-slot:activator="{ on }">
                  <v-icon style="font-size: 18px;" v-on="on" >clear</v-icon>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">Remove link</span>
                  </v-card-title>
                  <v-card-text>
                    <v-textarea
                      class="ma-2"
                      color="orange orange-darken-4"
                      outline
                      :counter="1000"
                      v-model="comment"
                      label="Source of knowledge"
                      required />
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="closeDeleteMenu(directedLink.link_id)">Cancel</v-btn>
                    <v-btn color="error darken-1" @click="deleteLink(parseInt(directedLink.link_id))">Delete</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

import ALL_WIKI_ENTITY_TYPE_DETAILS from '@/graphql/Wiki/AllEntityTypeDetails.gql'
import CREATE_WIKI_CHANGE_REQUEST from '@/graphql/Wiki/CreateWikiChangeRequest.gql'
import ALL_CURRENT_WIKI_ENTITIES from '@/graphql/Wiki/AllCurrentWikiEntities.gql'
import GET_WIKI_ENTITY from '@/graphql/Wiki/GetWikiEntity.gql'
import LOGGER from '@/graphql/Logger.gql'
export default {
  name: 'LinksSection',
  data () {
    return {
      allCurrentWikiEntities: [],
      allWikiEntityTypes: [],
      allWikiEntities: [],
      getWikiEntity: {},
      dialog: false,
      dialogDelete: {},
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
      newEntityName: '',
      newEntityTypeId: null,
      newEntityCheckbox: false,
      comment: ''
    }
  },
  computed: {
    ...mapState('wiki', ['entityId']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Link' : 'Edit Link'
    },
    allowedEntityTypes () {
      // allowed entity type for new entity
      return this.allWikiEntityTypes.filter(entityType => this.selectedDirectedLinkType.AllowedEntityTypeIds.includes(entityType.entity_type_id))
    },
    allowedWikiDirectedLinkTypes () {
      if (!this.getWikiEntity.EntityTypes.length || !this.allWikiEntityTypes) { return [] }
      let entityTypeIds = this.getWikiEntity.EntityTypes.map(entityEntityType => entityEntityType.entity_type_id)
      let entityTypes = this.allWikiEntityTypes.filter(entityType => entityTypeIds.indexOf(entityType.entity_type_id) > -1)
      return entityTypes.map(type => type.DirectedLinkTypes).flat()
    },
    // later: create a computed property "entityformatted" with entity types as first level of children
    directedEntityLinkTypes () {
      let res = (this.allowedWikiDirectedLinkTypes.length && this.getWikiEntity.DirectedLinks.length)
        ? [...new Set(this.getWikiEntity.DirectedLinks.map(a => a.directed_link_type_key))].map(key => this.allowedWikiDirectedLinkTypes.find(a => a.directed_link_type_key === key))
        : []
      return res
    },
    selectedDirectedLinkType () {
      return (Object.keys(this.editedItem).length !== 0 && this.allowedWikiDirectedLinkTypes) ? this.allowedWikiDirectedLinkTypes.find(a => a.directed_link_type_key === this.editedItem.directed_link_type_key) : {}
    },
    allowedCurrentWikiEntitiesBySelectedLinkType () {
      if (Object.keys(this.selectedDirectedLinkType).length === 0 || !this.allowedWikiDirectedLinkTypes.length || !this.allCurrentWikiEntities.length) { return [] }
      const linkTypeKey = this.selectedDirectedLinkType.directed_link_type_key
      const directedLinkType = this.allowedWikiDirectedLinkTypes.find(d => d.directed_link_type_key === linkTypeKey)
      let filteredEntities = this.allCurrentWikiEntities.filter(
        entity => entity.EntityTypes.some(entityType => directedLinkType.AllowedEntityTypeIds.includes(entityType.entity_type_id)))
      // remove current entity
      filteredEntities = filteredEntities.filter(e => e.entity_id !== this.getWikiEntity.entity_id)
      // remove entitites that are already linked for this link type
      let alreadyLinkedEntity = this.getWikiEntity.DirectedLinks.filter(
        directedLink => directedLink.directed_link_type_key === this.editedItem.directed_link_type_key)
      if (this.editedItem) {
        // List of linkedEntity already selected expeted the editedItem
        alreadyLinkedEntity = alreadyLinkedEntity.filter(l => l.linked_entity_id !== this.editedItem.linked_entity_id && l.link_id !== this.editedItem.link_id)
      }
      const alreadyLinkedEntityIds = alreadyLinkedEntity.map(directedLink => directedLink.linked_entity_id)
      // add current entity for edit
      filteredEntities = filteredEntities.filter(e => !alreadyLinkedEntityIds.includes(e.entity_id))
      return filteredEntities
    },
    disableSaveBtn () {
      let res = this.editedItem.directed_link_type_key === undefined ||
        (this.editedItem.directed_link_type_key && (this.editedItem.linked_entity_id === undefined || !this.editedItem.linked_entity_id))
      return res
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  methods: {
    ...mapMutations(['addError']),
    ...mapMutations('wiki', ['setEntityId', 'setViewedEntityDialog']),
    updateCreatedEntity (store, { data: { createWikiChangeRequest } }) {
      const data = store.readQuery({ query: ALL_CURRENT_WIKI_ENTITIES })
      data.allCurrentWikiEntities.push(...createWikiChangeRequest)
      store.writeQuery({ query: ALL_CURRENT_WIKI_ENTITIES, data })
    },
    onDone (resultObject) {
      this.newEntityName = ''
      this.newEntityTypeId = null
      this.newEntityCheckbox = false
      this.editedItem.linked_entity_id = resultObject.data.createWikiChangeRequest[0].entity_id
    },
    editItem (item) {
      this.editedIndex = this.getWikiEntity.DirectedLinks.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    async showEntity (id) {
      await this.setEntityId(id)
      this.setViewedEntityDialog(true)
    },
    onClickOpen (action, objectId, title) {
      this.$apollo.mutate({
        mutation: LOGGER,
        variables: {
          level: 'info',
          message: JSON.stringify({
            module: this.$route.name,
            action,
            objectId,
            title
          })
        }
      })
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    deleteLink (linkId) {
      this.$apollo.mutate({
        mutation: CREATE_WIKI_CHANGE_REQUEST,
        variables: {
          WikiChangeRequestInput: {
            target_type: 'wiki_link',
            target_id: linkId,
            request_type: 'delete',
            comment: this.comment || '',
            ChangeRequestFields: [{
              target_field: 'entity_id',
              new_value_fk: this.getWikiEntity.entity_id
            }]
          }
        }
      }).then((data) => {
        this.comment = ''
        this.dialogDelete[linkId] = false
      })
        .catch((error) => {
          if (error.networkError.statusCode === 401) {
            this.$auth0.login()
          } else {
            this.addError(error)
          }
        })
    },
    closeDeleteMenu (linkId) {
      this.dialogDelete[linkId] = false
      this.menu = ''
    }
  },
  apollo: {
    allWikiEntityTypes: {
      query: ALL_WIKI_ENTITY_TYPE_DETAILS
    },
    allCurrentWikiEntities: {
      query: ALL_CURRENT_WIKI_ENTITIES
    },
    getWikiEntity: {
      query: GET_WIKI_ENTITY,
      variables () {
        return {
          entity_id: parseInt(this.entityId)
        }
      },
      // update: (data) => data.entity.single,
      skip () {
        return this.$route.name !== 'wiki' || !this.entityId
      }
    }
  }
}
</script>
